const { PostFormApi, validateInputField } = require("../utils/func");

const onComplete = () => {
  const questionBox = document.querySelector("textarea[name='question']");
  if (questionBox) questionBox.value = "";

  const success = document.getElementById("success");
  const queryFormContainer = document.getElementById("queryFormContainer");
  const qr = document.getElementById("qr");
  const form = document.getElementById("askQueryQuestion");

  // Prefer jQuery animations if available; otherwise use simple display toggles.
  const hasJquery = typeof window !== "undefined" && window.jQuery;

  if (hasJquery) {
    if (qr) window.jQuery(qr).stop(true, true).fadeOut(200);
    if (queryFormContainer)
      window.jQuery(queryFormContainer).stop(true, true).fadeOut(200);
    if (form) window.jQuery(form).stop(true, true).fadeOut(200);

    if (success) window.jQuery(success).stop(true, true).fadeIn(200);
  } else {
    if (qr) qr.style.display = "none";
    if (queryFormContainer) queryFormContainer.style.display = "none";
    if (form) form.style.display = "none";

    if (success) success.style.display = "block";
  }
};

export const askQuestion = (e) => {
  e.preventDefault();

  const questionBox = document.querySelector("textarea[name='question']");
  const userEmailBox = document.querySelector("input[name='user-email']");
  const meetingIdBox = document.querySelector("input[name='meeting-id']");

  const isValid = validateInputField(questionBox);
  if (isValid !== 0) return;

  const formObject = {
    question: questionBox ? questionBox.value : "",
    userEmail: userEmailBox ? userEmailBox.value : "",
    meetingId: meetingIdBox ? meetingIdBox.value : "",
    submit: true,
  };

  if (typeof grecaptcha !== "undefined") {
    grecaptcha
        .execute("6LcIJ6cUAAAAABzDuwpRp8UWOkteEUrySZ2cUg1j", {
          action: "ada_process_query",
        })
        .then((token) => {
          formObject.token = token;
          return PostFormApi("api/query/process_query.php", formObject);
        })
        .then(() => onComplete());
  } else {
    PostFormApi("api/query/process_query.php", formObject).then(() =>
        onComplete()
    );
  }
};